module.exports = __webpack_public_path__ + "table-sort-desc.cf27d5b5fab8fbf684ad338b276f512d.png";